/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage } from 'sarsaparilla';
import { MobileSessionHandoff } from 'shared-ui/mobile-session';

import routesArray from './routesArray';
import VenuePage from '../src/containers/VenuePageWrapper';
import AvailabilityPage from '../src/containers/AvailabilityPage';
import OrderDetailsPage from '../src/containers/OrderDetailsPage';
import LotteryRegistrationPage from '../src/containers/LotteryRegistrationPage';
import LotteryWinnerConfirmationPage from '../src/containers/LotteryWinnerConfirmationPage';

const Components = {
    VenuePage,
    AvailabilityPage,
    OrderDetailsPage,
    LotteryRegistrationPage,
    LotteryWinnerConfirmationPage,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    // needed for mobile app to prevent login redirects
    routeComponents.push(
        <Route
            path="/permits/:permitId/mobile/session"
            key="mobileSession"
            element={<MobileSessionHandoff />}
        />
    );

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
